import React from 'react'
import lang from 'src/lang'
import { ServiceData } from 'src/utils/interface'

import openService_CN from 'src/i18n/zh_CN/OpenService/OpenService'
import openService_EN from 'src/i18n/en_US/OpenService/OpenService'

import dashboardImg from 'src/static/icons/dashboard.png'
import situationImg from 'src/static/icons/situation.png'
import gatewayImg from 'src/static/icons/gateway.png'
import networkTopologyImg from 'src/static/icons/networkTopology.svg'
import accessImg from 'src/static/icons/access.png'
import qosImg from 'src/static/icons/qos.png'
import statisticalImg from 'src/static/icons/statistical.png'
import alarmImg from 'src/static/icons/alarm.png'
import operationImg from 'src/static/icons/operation.svg'
import subuserImg from 'src/static/icons/subuser.png'

import ZeroContact from 'src/static/openService/ZeroContact.png'
import WANOptimization from 'src/static/openService/WANOptimization.png'
import IntelligentRoute from 'src/static/openService/IntelligentRoute.png'
import UnifiedCloud from 'src/static/openService/UnifiedCloud.png'
import ProductBannerSDWAN from 'src/static/openService/product_banner_SD-WAN.png'

// 采购带宽进行单位转换,bandwidthLimit带宽值, accuracy精度保留几位小数（默认2位）
export function getBandwidthLimit(bandwidthLimit: number | undefined, accuracy: number = 2, isSpecialSizes = false) {
  if (bandwidthLimit && typeof bandwidthLimit === 'number') {
    if(bandwidthLimit <= 1) {
      if(isSpecialSizes) {
        return `${bandwidthLimit.toFixed(accuracy)}`
      } else {
        return `${bandwidthLimit.toFixed(accuracy)}B`
      }
    }

    const k = 1000;
    let sizes = ['B','KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    if(isSpecialSizes) {
      sizes = ['','K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y']
    }
    // 求出bandwidthLimit所在单位区间是1000的几次方i之内
    const i = Math.floor(Math.log(bandwidthLimit) / Math.log(k))
  
    return (bandwidthLimit / Math.pow(k, i)).toFixed(accuracy) + ' ' + sizes[i]
  }
  return bandwidthLimit
}

// 从url上获取网关id
export function getGatewayIdFromUrl() {
  const str = window.location.hash.split('/sdwan/gateway/detail/')[1]
  return Number(str.split('?')[0])
}

// 是否是ip地址
export function isIPAddress(str: string) {
  const pattern = /^((2[0-4]\d|25[0-5]|1\d\d|[1-9]\d|\d)\.){3}(2[0-4]\d|25[0-5]|1\d\d|[1-9]\d|\d)$/
  return pattern.test(str)
}

// 是否是mac地址
export function isMacAddress(str: string) {
  const pattern = /^[A-Fa-f0-9]{2}([-:]?[A-Fa-f0-9]{2})([-:.]?[A-Fa-f0-9]{2})([-:]?[A-Fa-f0-9]{2})([-:.]?[A-Fa-f0-9]{2})([-:]?[A-Fa-f0-9]{2})$/
  return pattern.test(str)
}

// 是否是IP网段
export function isIPNetworkSegment(str: string) {
  const pattern = /^((2[0-4]\d|25[0-5]|1\d\d|[1-9]\d|\d)\.){3}(2[0-4]\d|25[0-5]|1\d\d|[1-9]\d|\d)\/(2[0-4]\d|25[0-5]|1\d\d|[1-9]\d|\d)$/
  return pattern.test(str)
}

// 比特大小转换
export function bytesToSize(bytes: number) {
  if (bytes <= 1) return `${bytes}B`

  const k = 1024;
  const sizes = ['B','KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
}

// // 秒转换成xx分钟
// export function getDuration(second: number) {
//   // 转为分钟
//   const minute = second / 60
//   return minute > 1 ? `${Math.floor(second / 60)}${lang.Common.Minute}` : lang.Common.LessThanMinute
// }

export function jumpToUCOpenservice() {
  const data = {
    zh_CN: {
      title: 'SD-WAN',
      introduction: openService_CN.titleLabel,
      background: ProductBannerSDWAN,
      descriptions: [{
        icon: ZeroContact,
        title: openService_CN.ZeroContact,
        description: openService_CN.ZeroContactDetail
      },{
        icon: IntelligentRoute,
        title: openService_CN.IntelligentRoute,
        description: openService_CN.IntelligentRouteDetail
      },{
        icon: WANOptimization,
        title: openService_CN.WANOptimization,
        description: openService_CN.WANOptimizationDetail
      },{
        icon: UnifiedCloud,
        title: openService_CN.UnifiedCloud,
        description: openService_CN.UnifiedCloudDetail
      }]
    } as ServiceData,
    en_US: {
      title: 'SD-WAN',
      introduction: openService_EN.titleLabel,
      background: ProductBannerSDWAN,
      descriptions: [{
        icon: ZeroContact,
        title: openService_EN.ZeroContact,
        description: openService_EN.ZeroContactDetail
      },{
        icon: IntelligentRoute,
        title: openService_EN.IntelligentRoute,
        description: openService_EN.IntelligentRouteDetail
      },{
        icon: WANOptimization,
        title: openService_EN.WANOptimization,
        description: openService_EN.WANOptimizationDetail
      },{
        icon: UnifiedCloud,
        title: openService_EN.UnifiedCloud,
        description: openService_EN.UnifiedCloudDetail
      }]
    } as ServiceData
  }
  window.sessionStorage.setItem('open-service-data', JSON.stringify(data))
  window.location.href = `${window.location.origin}/#/uc/openService`
}

export function getMenu() {
  const menu = [
    // 菜单内容
    { key: 'dashboard-overview', to: '/sdwan/dashboard/overview', title: lang.Common.Overview, icon: React.createElement('img', { src: dashboardImg, className: 'menu-icon' }) },
    // { key: 'situation-center', to: '/sdwan/dashboard/situation', title: lang.Common.SituationCenter, icon: React.createElement('img', { src: situationImg, className: 'menu-icon' }) },
    { key: 'statistical-analysis', to: '/sdwan/statistical-analysis/detail', title: lang.StatisticalAnalysis.Detail.StatisticalAnalysis, icon: React.createElement('img', { src: statisticalImg, className: 'menu-icon' }) },
    // { key: 'network-topology', to: '/sdwan/NetworkTopology/index', title: lang.Common.NetworkTopology, icon: React.createElement('img', { src: networkTopologyImg, className: 'menu-icon' }) },
    { key: 'gateway-list', to: '/sdwan/gateway', title: lang.Common.GatewayList, icon: React.createElement('img', { src: gatewayImg, className: 'menu-icon' }) },
    { key: 'flow-record', to: '/sdwan/flow-control/record', title: lang.Common.FlowLog, icon: React.createElement('img', { src: operationImg, className: 'menu-icon' }) },
    // { key: 'access-control-control', title: lang.Common.AccessControl, icon: React.createElement('img', { src: accessImg, className: 'menu-icon' }), children: [
    //   { key: 'access-rule', to: '/sdwan/access-control/control', title: lang.Common.AccessRule},
    //   { key: 'flow-record', to: '/sdwan/flow-control/record', title: lang.Common.FlowLog },
      // { key: 'control-log', to: '/sdwan/flow-control/log', title: lang.Common.ControlLog },
      // { key: 'access-control-nat', to: '/sdwan/access-control/nat', title: lang.AccessControl.NatList.NATSession }
    // ] },
    // { key: 'qos-plot-control', to: '/sdwan/qos-plot/control', title: lang.Common.Qos, icon: React.createElement('img', { src: qosImg, className: 'menu-icon' }) },
    // { key: 'alarm-list', to: '/sdwan/alarm-event/list', title: lang.StatisticalAnalysis.Detail.AlarmList, icon: React.createElement('img', { src: alarmImg, className: 'menu-icon' }) },
    // { key: 'operation-log', to: '/sdwan/operation-log', title: lang.Common.OperationLog, icon: React.createElement('img', { src: operationImg, className: 'menu-icon' }) },
  ]

  // 是否有子用户管理的权限
  // const isChild = window.localStorage.getItem('sdwan-isChild')
  // if(!isChild) {
  //   menu.push({ key: 'subuser', to: '/sdwan/subuser', title: lang.SubUser.SubUser.SubUserManage, icon: React.createElement('img', { src: subuserImg, className: 'menu-icon' }) })
  // }

  // 当前用户至少有一项渠道管理菜单权限列表
  const authMenuArr = JSON.parse(window.localStorage.getItem('sdwan-authMenu') || '')
  const authKeys = ['channelGaaList', 'channelPopServerPool','channelPrivateLinePool','channelUserNetTopology','channelUserOpLog','channelUserOrder']
  if(authMenuArr && Array.isArray(authMenuArr) && authKeys.find(item => authMenuArr.find(j => item === j))) {
    const cmiMenuItem = { key: 'cmi-menu', title: lang.Common.ChannelManagement, icon: React.createElement('img', { src: accessImg, className: 'menu-icon' }), children: [] as any }
    authMenuArr?.includes('channelPopServerPool') && cmiMenuItem.children.push({ key: 'pop-servers', to: '/sdwan/channel/pop-servers/list', title: lang.Common.PopServers })
    authMenuArr?.includes('channelPrivateLinePool') && cmiMenuItem.children.push({ key: 'dedicated-line', to: '/sdwan/channel/dedicated-line/list', title: lang.Common.PrivateLine })
    authMenuArr?.includes('channelUserNetTopology') && cmiMenuItem.children.push({ key: 'user-netTopology', to: '/sdwan/channel/user-netTopology', title: lang.Common.NetTopology })
    authMenuArr?.includes('channelUserOpLog') && cmiMenuItem.children.push({ key: 'operate-log', to: '/sdwan/channel/operation-log', title: lang.Common.OperationLog })
    authMenuArr?.includes('channelUserOrder') && cmiMenuItem.children.push({ key: 'user-order', to: '/sdwan/channel/user-order', title: lang.Common.UserOrder })
    authMenuArr?.includes('channelGaaList') && cmiMenuItem.children.push({ key: 'saas-list', to: '/sdwan/channel/saasList', title: lang.Common.UserWhitelist })
    authMenuArr?.includes('channelUserFlowLog') && cmiMenuItem.children.push({ key: 'flow-log', to: '/sdwan/channel/userBehaviorLog', title: lang.Common.UserBehaviorLog })
    authMenuArr?.includes('channelCrossBorder') && cmiMenuItem.children.push({ key: 'cross-border', to: '/sdwan/channel/crossBorder', title: lang.Common.CrossBorder })
    menu.push(cmiMenuItem)
  }
  return menu
}

// 将ip地址转化为2进制
export function ipToNumber(ip: string) {  
  var num = 0;  
  if(ip === "") {  
      return num;  
  }      
  var aNum = ip.split(".");   
  if(aNum.length !== 4) {  
      return num;  
  }     
  num += parseInt(aNum[0]) << 24;  
  num += parseInt(aNum[1]) << 16;  
  num += parseInt(aNum[2]) << 8;  
  num += parseInt(aNum[3]) << 0;  
  num = num >>> 0;//这个很关键，不然可能会出现负数的情况  
  return num;    
}

// 多维数组拍平
export function flatten(arr: any[]): any {
  return arr.reduce(function (pre: [], cur: []) {
    if (!Array.isArray(cur)) {
      return [...pre, cur]
    } else {
      return [...pre, ...flatten(cur)]
    }
  }, [])
}

// acl qos snat dnat五元组ip校验规则 需要srcIp和destIp
export function ipTest(form: any) {
  return ({
  validator(_: any, value: string) {
    if(!value) return Promise.resolve()

    const ipTest =/^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)(\/\d+)?$/

    if(form.getFieldValue('srcIp') === form.getFieldValue('destIp'))
      return Promise.reject(lang.Common.IpNotEqual)

    if(!ipTest.test(value)) return Promise.reject(lang.Common.IPError)

    const ipArr = value.split('/')[0].split('.').map(item => Number(item))
    const netPart = Number(value.split('/')[1])

    // ip为0.0.0.0时网段必须为0
    if(ipArr.every(item => item === 0)) {
      if(netPart === 0) return Promise.resolve()

      return Promise.reject(lang.Common.IPError)
    }

    if(netPart > 32 || netPart < 1)
      return Promise.reject(lang.Common.NetPartRange)

    // ip第一个不能为0
    if(ipArr[0] === 0 && value.split('/').length < 2)
      return Promise.reject(lang.Common.IPError)

    // ip首尾为0时，网段1-31
    if((ipArr[0] === 0 || ipArr[3] === 0) && netPart > 31)
      return Promise.reject(lang.Common.IPError)

    return Promise.resolve()
  }
})}

// acl qos snat dnat五元组端口校验规则
export function portTest() {
  return ({
  validator(_: any, value: string) {
    if(!value) return Promise.resolve()

    if(!/(^[1-9]\d*$)|(^\d+-\d+$)/.test(value))
      return Promise.reject(lang.Common.PortError)

      console.log(value)
    const arr = value.split('-')
    if(Number(arr[0]) > Number(arr[1]))
      return Promise.reject(lang.Common.PortRange)

    // 检查端口范围在1-65535(特殊情况 0-0)
    // 不合法
    // const isInValid = arr.some(str => {
    //   if(Number(str) < 1 || Number(str) > 65535) {
    //     return true
    //   }
    // })
    // if(isInValid) {
    //   return Promise.reject(lang.Common.PortValueErrorTips)
    // }

    return Promise.resolve()
  }
})}

// 域名检测
export function domainTest(value: string) {
  // 域名格式检测
  const domainRep = /^([*][.]|[.])?[-a-zA-Z0-9]{2,62}(\.[-a-zA-Z0-9]{2,62})+$/
  // 域名首尾-检测
  const formatRep = /(^-)|\.-|-\.|(-$)/

  return domainRep.test(value) && !formatRep.test(value)
}

// 获取随机颜色
export function getRandomColor() {
  const r = Math.floor(Math.random()*256)
  const g = Math.floor(Math.random()*256)
  const b = Math.floor(Math.random()*256)

  return `rgb(${r},${g},${b})`
}